import React, { Component } from 'react';
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import "ag-grid-enterprise";
import { CommonValidationMessages } from '../../../utils/Messages';
import DateRangeField from '../../../components/dateRangeField/DateRangeField';
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown';
import TextInput from '../../../components/UIComponent/TextInput';
import TransactionReoprtServices from '../../../services/axiosServices/apiServices/TransactionReportsServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { SelectItemListPopUp } from '../../../components/dropdown/SelectItemListPopUp';
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import moment from 'moment';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import autoTable from 'jspdf-autotable';
import jsPDF from 'jspdf';

class ItemLedgerReport extends Component {
    constructor(props) {
        super(props)
        this.transactionReoprtServices = new TransactionReoprtServices();
        this.SwalServices = new SwalServices();
        this.masterEntryServices = new MasterEntryServices();
        this.gridRef = React.createRef();
        this.state = {
            idCompany: null,
            selectedRecord: 'all',
            isTable2Expanded: false,
            isTable3Expanded: false,
            rowData: [],
            colDefs: [
                { field: "id", headerName: "Sr no", filter: true, floatingFilter: true, minWidth: window.innerWidth * 0.01, flex: 0.6 },
                { field: "date", headerName: "Date", filter: true, floatingFilter: true, minWidth: window.innerWidth * 0.06, flex: 0.6 },
                { field: "description", headerName: "Description", filter: true, floatingFilter: true, minWidth: window.innerWidth * 0.2, flex: 1.5 },
                { field: "inward", headerName: "Inward", filter: true, floatingFilter: true, minWidth: window.innerWidth * 0.06, flex: 0.6 },
                { field: "outward", headerName: "Outward", filter: true, floatingFilter: true, minWidth: window.innerWidth * 0.06, flex: 0.6 },
                { field: "currentBalance", headerName: "Balance", filter: true, floatingFilter: true, minWidth: window.innerWidth * 0.1, flex: 1.0 },
            ],
            requestDetails: {
                startDate: "",
                endDate: "",
                idGeneralProduct: "",
                aCCSubHeadList: [],
                idItem: "",
                itemIdLabel: "",
                itemList: [],
                opQty: "",
                balQty: "",
            },
            validState: {
                isValid: true,
                error: {}
            },
            validationRules: {
                startDate: [{ type: "require", message: CommonValidationMessages.FieldRequired.replace("{0}", "from date") }],
                endDate: [{ type: "require", message: CommonValidationMessages.FieldRequired.replace("{0}", "to date") }],
                idItem: [{ type: "require", message: CommonValidationMessages.FieldRequired.replace("{0}", "item") }],
            },
            paginationPageSize: 50,
            rowHeight: 40,
            isSelectItemPopUp: false,
            selectItemColDefs: [
                {
                    field: "itemCategory",
                    headerName: "Item Category",
                    minWidth: window.innerWidth * 0.06,
                    flex: 0.6,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemCategoryDesc",
                    headerName: "Item Category Desc",
                    minWidth: window.innerWidth * 0.06,
                    flex: 0.6,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "searchText",
                    headerName: "Search Text",
                    minWidth: window.innerWidth * 0.05,
                    flex: 0.5,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "drawingNo",
                    headerName: "Drawing No",
                    minWidth: window.innerWidth * 0.08,
                    flex: 0.8,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemName",
                    headerName: "Item Name",
                    minWidth: window.innerWidth * 0.15,
                    flex: 1.5,
                    filter: true,
                    floatingFilter: true,
                },
            ],
        };
    }

    componentDidMount = () => {
        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany }, () => {
                this.getMaster_ItemSelectbyItemType()
            });
        }
    }

    handleChange = (event, name) => {
        let details = this.state.requestDetails;
        let value = event.target.value;
        details[name] = value;
        this.setState({ requestDetails: details });
    }

    handleChangeForDropdown = (event, name, field) => {
        let details = this.state.requestDetails;
        let value = event.value;
        details[name] = value;
        this.setState({ requestDetails: details });
    }

    handleRecordSelect = (value) => {
        this.setState({ selectedRecord: value });
    }

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.requestDetails,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    getItemLedgerReportRecords = () => {
        let isValid = this.isValidAllFields();

        const requestCopy = {
            fromDate: this.state.requestDetails.startDate,
            toDate: this.state.requestDetails.endDate,
            idItem: this.state.requestDetails.idItem,
            idCompany: this.state.idCompany
        };

        if (isValid) {
            this.transactionReoprtServices.getItemLedgerReportRecords(requestCopy).then((response) => {
                console.log(response)
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let requestDetails = this.state.requestDetails;

                    let res = response.responseItem.responseContent.transactions.map((x) => ({
                        ...x,
                        date: x.date ? moment(x.date).format('DD-MM-YYYY') : ''
                    }));

                    requestDetails.opQty = response.responseItem.responseContent.openingStock;
                    requestDetails.balQty = response.responseItem.responseContent.closingBalance;

                    this.setState({
                        rowData: res,
                        requestDetails: requestDetails
                    });
                } else {
                    this.SwalServices.showError(response.message);
                    this.setState({ isLoading: false });
                }
            }).catch((error) => {
                console.error("Error fetching ledger report:", error);
            });
        }
    }

    getMaster_ItemSelectbyItemType = (label, name) => {
        let request = ['', this.state.idCompany];
        this.masterEntryServices.getMaster_ItemSelectbyItemType(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                let itemObject = this.state.requestDetails;
                itemObject.itemList = data;
                this.setState({ requestDetails: itemObject });
            }
        });
    }

    setOpenModel2 = () => {
        this.setState({ isSelectItemPopUp: !this.state.isSelectItemPopUp });
    };

    handleDropdownCellClick = (event) => {
        let data = this.state.requestDetails;
        data.idItem = event.data.idItem;
        data.itemIdLabel = event.data.itemName;
        this.setState({ requestDetails: data, isSelectItemPopUp: !this.state.isSelectItemPopUp });
    };

    handleOnClick = () => {
        this.setOpenModel2();
    }

    getPinnedBottomRowData = () => {
        const totalInward = this.state.rowData.reduce((sum, r) => sum + (r.inward || 0), 0);
        const totalOutward = this.state.rowData.reduce((sum, r) => sum + (r.outward || 0), 0);
        return [{ sr_no: "Total", date: "", description: "", inward: totalInward, outward: totalOutward, currentBalance: null }];
    }

    onExportExcel = () => {
        const { fromDate, toDate, itemIdLabel } = this.state.requestDetails;

        if (this.gridRef.current && this.gridRef.current.api) {
            const csvData = this.gridRef.current.api.getDataAsCsv();

            const customHeader = [
                [`Item Name: ${itemIdLabel}`, '', '', ''].join(','),
                [`From: ${moment(fromDate).format('DD-MM-YYYY')} To: ${moment(toDate).format('DD-MM-YYYY')}`, '', '', ''].join(','),
                ''
            ].join('\r\n');

            const finalCsv = `${customHeader}\r\n${csvData}`;

            const blob = new Blob([finalCsv], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'ItemLedger_Report.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            console.warn("Grid API not ready");
        }
    };

    onExportPdf = () => {
        const doc = new jsPDF();

        const { fromDate, toDate, itemIdLabel } = this.state.requestDetails;

        const pageWidth = doc.internal.pageSize.getWidth();

        // Header content
        const headerLines = [
            `Item Name: ${itemIdLabel}`,
            `From: ${moment(fromDate).format('DD-MM-YYYY')} To: ${moment(toDate).format('DD-MM-YYYY')}`
        ];

        // Header styles
        const headerFontSize = 12;
        const headerTextColor = [80, 80, 80]; // white
        const headerBgColor = [245, 245, 245]; // blue
        const lineHeight = 8;
        const padding = 2;

        // Calculate total header height
        const totalHeaderHeight = headerLines.length * lineHeight + padding * 2;

        // Draw background rectangle for header
        doc.setFillColor(...headerBgColor);
        doc.rect(0, 0, pageWidth, totalHeaderHeight, 'F');

        // Set text styles
        doc.setFontSize(headerFontSize);
        doc.setTextColor(...headerTextColor);

        // Draw each header line centered
        headerLines.forEach((line, i) => {
            const textWidth = doc.getTextWidth(line);
            const x = (pageWidth - textWidth) / 2;
            const y = padding + (i + 1) * lineHeight - 2;
            doc.text(line, x, y);
        });

        // Prepare table data
        const exportableCols = this.state.colDefs.filter(col => col.headerName !== "Sr No");

        const rowData = [];
        this.gridRef.current.api.forEachNodeAfterFilterAndSort((node) => {
            rowData.push(exportableCols.map(col => node.data[col.field]));
        });

        const pinnedBottomRows = this.gridRef.current.api.getPinnedBottomRowCount();
        for (let i = 0; i < pinnedBottomRows; i++) {
            const pinnedNode = this.gridRef.current.api.getPinnedBottomRow(i);
            rowData.push(exportableCols.map(col => pinnedNode.data[col.field]));
        }

        const columnHeaders = exportableCols.map(col => col.headerName);

        // Render table below header
        autoTable(doc, {
            head: [columnHeaders],
            body: rowData,
            startY: totalHeaderHeight + 4, // leave space below header
            styles: { fontSize: 8 },
            headStyles: { fillColor: [63, 140, 255], textColor: 255 },
        });

        doc.save("Itemledger-report.pdf");
    };

    render() {

        return (
            <div className='item-wise-stock-detail-report'>
                <div className="data-display">
                    <div className="data-display-inner">
                        <div className='search-grp bg-white shadow-normalShadow rounded-[10px] p-[10px] mb-[10px]'>
                            <p className='mb-[5px] font-semibold text-blue text-[16px]'>Select details</p>
                            <div className='item-set flex gap-[15px]'>
                                <div className='item-grp w-full grid grid-cols-6 gap-[15px] items-start'>

                                    <div className="input-grp">
                                        <label>From Date</label>
                                        <TextInput
                                            type="date"
                                            id="startDate"
                                            name="startDate"
                                            value={this.state.requestDetails.startDate}
                                            handleChange={(event) => this.handleChange(event, "startDate")}
                                            className={this.state.validState?.error?.startDate ? "error" : ""}
                                        />
                                    </div>

                                    <div className="input-grp">
                                        <label>To Date</label>
                                        <TextInput
                                            type="date"
                                            id="endDate"
                                            name="endDate"
                                            value={this.state.requestDetails.endDate}
                                            handleChange={(event) => this.handleChange(event, "endDate")}
                                            className={this.state.validState?.error?.endDate ? "error" : ""}
                                        />
                                    </div>

                                    {/* <div className="input-grp col-span-2">
                                        <label>
                                            Record Type
                                        </label>
                                        <div className='radio-grp grid grid-cols-2 gap-2 '>
                                            {[{ id: 'all', label: 'All Records' }, { id: 'selection', label: 'Selection Wise' }].map(({ id, label }) => {
                                                const active = this.state.selectedRecord === id;
                                                return (
                                                    <button
                                                        key={id}
                                                        type="button"
                                                        onClick={() => this.handleRecordSelect(id)}
                                                        className={`flex items-center gap-2.5 px-3 py-2.5 rounded-lg border text-[14px] font-semibold transition-all duration-150 cursor-pointer text-left w-full
                                            ${active
                                                                ? 'border-blue bg-[#EEF2FF] text-blue'
                                                                : 'border-[#DDE3F0] bg-[#F8FAFF] text-[#7A8BB0] hover:border-blue/40 hover:bg-[#F3F6FF]'
                                                            }`}
                                                    >
                                                        <span className={`w-4 h-4 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-all duration-150
                                            ${active ? 'border-blue' : 'border-[#B8C4DC]'}`}>
                                                            {active && <span className="w-2 h-2 rounded-full bg-blue block" />}
                                                        </span>
                                                        {label}
                                                    </button>
                                                );
                                            })}
                                        </div>
                                    </div> */}

                                    {/* <div className='input-grp w-full col-span-2'>
                                        <label>Select acc. head</label>
                                        <MultiSelectDropdown
                                            drpIdentity="Acc sub head"
                                            options={this.state.requestDetails.aCCSubHeadList}
                                            value={this.state.requestDetails.idGeneralProduct ? this.state.requestDetails.aCCSubHeadList.find(x => x.value === this.state.requestDetails.idGeneralProduct) : 0}
                                            onChange={(event) =>
                                                this.handleChangeForDropdown(event, "GeneralProduct")
                                            }
                                            className={` ${this.state.validState?.error?.idGeneralProduct ? "error" : ""}`}
                                        />
                                    </div> */}
                                    <div className='input-grp w-full col-span-2'>
                                        <label>Select item</label>
                                        {/* <MultiSelectDropdown
                                            drpIdentity="Select item"
                                            options={this.state.requestDetails.itemList}
                                            value={this.state.requestDetails.idItem ? this.state.requestDetails.itemList.find(x => x.value === this.state.requestDetails.idItem) : 0}
                                            onChange={(event) =>
                                                this.handleChangeForDropdown(event, "idItem")
                                            }
                                            className={` ${this.state.validState?.error?.idItem ? "error" : ""}`}
                                        /> */}
                                        <TextInput
                                            id="SelectItem"
                                            name="SelectItem"
                                            value={this.state.requestDetails.itemIdLabel}
                                            handleOnClick={(event) => this.handleOnClick(event, "itemList")}
                                            className={this.state.validState?.error?.idItem !== undefined ? "error" : ""}
                                        />
                                    </div>
                                    <div className='input-grp'>
                                        <label>Opening Qty</label>
                                        <TextInput
                                            type='number'
                                            id='opQty' name='opQty'
                                            value={this.state.requestDetails.opQty}
                                            handleChange={(event) => this.handleChange(event, 'opQty')}
                                            disabled
                                        />
                                    </div>
                                    <div className='input-grp'>
                                        <label>Balance Qty</label>
                                        <TextInput
                                            type='number'
                                            id='balQty' name='balQty'
                                            value={this.state.requestDetails.balQty}
                                            handleChange={(event) => this.handleChange(event, 'balQty')}
                                            disabled
                                        />
                                    </div>
                                    <div className='btn-grp'>
                                        <button
                                            onClick={() => this.getItemLedgerReportRecords()}
                                            className='prm-btn'>Search</button>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="table w-full cursor-default bg-white shadow-normalShadow rounded-[10px] pb-[50px] pt-[10px] px-[10px]">
                            <div className="table-1 h-[56vh] w-full rounded-[5px]">
                                <div className="table-inner flex items-center justify-between mb-2">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Item ledger report</h1>
                                    <div className='btn-grp flex items-center gap-2.5'>
                                        {this.state.rowData.length > 0 ?
                                            <>
                                                <button
                                                    className='prm-btn h-fit text-[14px] rounded-[8px] px-[16px] py-[8px]'
                                                    onClick={() => this.onExportExcel()}
                                                >
                                                    Export to Excel
                                                </button>
                                                <button
                                                    className='prm-btn h-fit text-[14px] rounded-[8px] px-[16px] py-[8px]'
                                                    onClick={() => this.onExportPdf()}
                                                >
                                                    Export to PDF
                                                </button>
                                            </>
                                            : null}
                                    </div>
                                </div>
                                <AgGridReact
                                    ref={this.gridRef}
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    rowSelection={this.rowSelection}
                                    rowClassRules={{
                                        "sum-row": (params) => params.node.rowPinned === "bottom"
                                    }}
                                    pinnedBottomRowData={this.getPinnedBottomRowData()}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <SelectItemListPopUp
                    modalName={"Select Item"}
                    selectItemList={this.state.requestDetails.itemList}
                    colDefs={this.state.selectItemColDefs}
                    isModalOpen={this.state.isSelectItemPopUp}
                    setOpenModel={this.setOpenModel2.bind(this)}
                    handleSelectChange={this.handleDropdownCellClick}
                />
            </div>
        );
    }
}

export default ItemLedgerReport;